import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMember,
  BackendMutationRemoveCustomerMemberArgs,
} from 'src/types/backend';

import { CUSTOMER_MEMBER_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation RemoveCustomerMember($customerId: ID!, $email: String!) {
    removeCustomerMember(customerId: $customerId, email: $email) {
      ...CustomerMember
    }
  }
  ${CUSTOMER_MEMBER_FRAGMENT}
`;

type Variables = BackendMutationRemoveCustomerMemberArgs;
type Result = BackendCustomerMember;

export const removeCustomerUser = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
